module.exports = __webpack_public_path__ + "img/7_hills.9505957a.jpg";